// extracted by mini-css-extract-plugin
export default {"modalBodyStyle":"copyShowModal_modalBodyStyle__J0pMu","modal":"copyShowModal_modal__VkjK7","marginArea":"copyShowModal_marginArea__Y-2Q3"};